import React from 'react';
import VideoLinkPageTemplate from './VideoLinkPageTemplate';
import ProjectDetails from './ProjectDetails';
import PleaseHoldImage from '../assets/images/PleaseHoldStill.jpg';

function Breathe() {
  const title = "PLEASE HOLD (2025)";
  const subtitle = "Short Film, 6mins";
  const description = "After waking up in a desolate field, a man follows a strange series of rotary phones that lead him through corporate hotlines and empty pleasantries, forcing him to confront his work-driven identity.";
  const imageSrc = PleaseHoldImage;

  const credits = [
    { role: "Directors and Editors", name: "KENNETH NGUYEN, REESE ROBERS" },
    { role: "Writers", name: "KENNETH NGUYEN, REESE ROBERS, ARYAN MEDAM" },
    { role: "Music and Sound", name: "ARYAN MEDAM" },
    
  ];

  const keycast = [
    { role: "Mike", name: "AARON HOFFMAN" },
    { role: "Sandra", name: "MARISSA MIDDLETON" }

  ];

  const festivals = [
    { name: "Adrenaline Film Premiere 2025", note: "Best Lead Actor" }
  ];

  return (
    <div>
      <VideoLinkPageTemplate
        title={title}
        subtitle={subtitle}
        description={description}
        imageSrc={imageSrc} // Pass the image source instead of the video.
      />
      
      <ProjectDetails
        festivals={festivals}
        festivalHeading="AWARDS"
        credits={credits}
        cast={keycast}
      />

    </div>
  );
}

export default Breathe;
